module.exports = __webpack_public_path__ + "components/modal-app-popup/static/app-icon-234f417e98e61df744759d987af1dda6.svg";